<!-- admin-categories.component.html -->
<div class="p-6 bg-white rounded shadow">
  <h2 class="text-xl font-bold mb-4">Category Management</h2>

  <!-- Root category add form -->
  <div class="mb-6">
    <h2 class="text-lg font-semibold mb-2">Add Root Category</h2>
    <form [formGroup]="rootCategoryForm" (ngSubmit)="addRootCategory()" class="flex gap-2">
      <input type="text" formControlName="name" placeholder="Root Category Name"
             class="border rounded p-2 flex-1" />
      <button type="submit"
              class="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded">
        Add Root
      </button>
    </form>
  </div>

  <app-category-tree [categories]="categories"></app-category-tree>
</div>
